import React from "react"
import Faq from "../base-pages/faq"

const FaqCN = () => {
  return <Faq lang="cn" />
}

export default FaqCN
